import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import { getTenantSubcategoryMT, getTenantSubcategorySTNL } from '../../utils';
import SelectTeam from '../SelectTeam-new/SelectTeam';

const PropertyForm = ({theme = 'white', width, data, paneIndex, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>Add Property</div>
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='NAME'
                       label='Name'
                       value={data.NAME}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='ADDRESS'
                       label='Address'
                       value={data.ADDRESS}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='CITY'
                       label='City'
                       value={data.CITY}
                       handleParentChange={handleParentChange}
                />
                <div className='form-address'>
                    <div className='form-state'>
                        <Dropdown theme={theme}
                                  optionsType='states'
                                  optionKey='abbr'
                                  optionLabelKey='name'
                                  value={data.STATE}
                                  valueKey='STATE'
                                  label='State'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                    </div>
                    <div className='form-zip'>
                        <Input theme={theme}
                               valueType='text'
                               name='ZIP'
                               label='Zip'
                               value={data.ZIP}
                               handleParentChange={handleParentChange}
                        />
                    </div>
                </div>
                <Dropdown 
                    theme={theme}
                    width={width}
                    optionsType='source'
                    name='SOURCE'
                    valueKey='SOURCE'
                    label='Source'
                    value={data.SOURCE}
                    data={data}
                    handleParentChange={handleParentDropdownChange}
                />
                <Dropdown 
                    optionKey='code'
                    optionLabelKey='code'
                    data={data}
                    optionsType='status'
                    value={'Off Market'}
                    valueKey="STATUS"
                    label="STATUS"
                    disabled
                    handleParentChange={handleParentDropdownChange}
                />
                <Dropdown
                    theme={theme}
                    width={width}
                    data={data}
                    optionsType="transaction"
                    value={data.TRANSACTION_TYPE}
                    valueKey="TRANSACTION_TYPE"
                    label="Transaction Type"
                    handleParentChange={handleParentDropdownChange}
                />
                <Dropdown
                    theme={theme}
                    width={width}
                    data={data}
                    optionsType="market"
                     optionKey='code'
                    optionLabelKey='name'
                    value={data.market}
                    valueKey="market"
                    label="Market"
                    handleParentChange={handleParentDropdownChange}
                    
                />
                <Dropdown theme={theme}
                        optionsType='category'
                        optionKey='code'
                        optionLabelKey='name'
                        value={data.CATEGORY}
                        valueKey='CATEGORY'
                        label='Property Category'
                        data={data}
                        handleParentChange={handleParentDropdownChange}
                        />
                <Dropdown theme={theme}
                        optionsType='type'
                        optionKey='code'
                        optionLabelKey='name'
                        value={data.TYPE}
                        valueKey='TYPE'
                        label='Property Type'
                        data={data}
                        handleParentChange={handleParentDropdownChange}
                    />
                    {
                        (data.TYPE === 'STNL' && data.CATEGORY && data.TRANSACTION_TYPE !== "Referral" && data.SOURCE !="HSC") && getTenantSubcategorySTNL({data, handleChangeDropdown : handleParentDropdownChange, theme})
                    }
                    {
                        (data.TYPE === 'MT' && data.CATEGORY  && data.TRANSACTION_TYPE !== "Referral" && data.SOURCE !="HSC") && getTenantSubcategoryMT({data, handleChangeDropdown : handleParentDropdownChange, theme})
                    }
                    <Input theme={theme}
                        valueType='integer'
                        name={data.SOURCE == "HSC" ? "HSC_PRICE" : "LIST_PRICE"}
                        label='List Price'
                        value={data.SOURCE == "HSC" ? data.HSC_PRICE : data.LIST_PRICE}
                        handleParentChange={handleParentChange}
                        isDollar
                    />
                    <Input theme={theme}
                        valueType='percent'
                        name='CAPITALIZATION_RATE'
                        label='Cap Rate'
                        value={data.CAPITALIZATION_RATE}
                        handleParentChange={handleParentChange}
                    />
                    <SelectTeam
                        value={data.LISTING_AGENT_1}
                        valueKey="LISTING_AGENT_1"
                        label="Agent"
                        data={data}
                        handleParentChange={handleParentDropdownChange}
                    />
            </React.Fragment>
        ),
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                <div className={`form-slider-icon ${theme} active`}/>
            </div>
            {
                panes[paneIndex]
            }
            <React.Fragment>
                <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                <button className='button-new positive'>Submit</button>
            </React.Fragment>
        </form>
    )
};

PropertyForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    width: PropTypes.number,
    data: PropTypes.object.isRequired,
    paneIndex: PropTypes.number.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
};

export default PropertyForm;